import React, { useState } from "react";
import "./index.css"
import vectormail from "../../assets/Vector.svg"
import whatsappicon from "../../assets/whatsapcon.svg"
import instagramicon from "../../assets/instacon.svg"
import faceboookicon from "../../assets/fbcon.svg"
import twittericon from "../../assets/twittercon.svg"
import phoneicon from "../../assets/phonecon.svg"
import {Link} from 'react-router-dom'
export const ReachOut = () => {

    return (
        <div className="container-art-1 my-3  ">
            <div className="d-flex justify-content-center align-item-center">
                <div className="lead-sub">Have any Questions?</div>
            </div>
            <br />
            <div className="d-flex justify-content-center ">
                <div className="w-100">
                    <div className="reach-border">
                        <div className="text-center">Reach us via</div>
                        <div className="pt-3">
                            <div className="flex-sys justify-content-between align-items-center">
                                <div className="mb-4">
                                    <Link  to="mailto:someone@example.com" target="_blank" rel="noopener noreferrer">
                                        <div className="d-flex align-items-center">
                                            <div className="pr-2"><img src={vectormail} /></div>
                                            <div>mail</div>

                                        </div>
                                    </Link>

                                </div>
                                <div className="mb-4">
                                    <Link>
                                        <div className="d-flex align-items-center">
                                            <div className="pr-2"><img src={phoneicon} /></div>
                                            <div>phone</div>

                                        </div>
                                    </Link>

                                </div>
                                <div className="mb-4">
                                    <Link  to="https://whatsapp.com" target="_blank" rel="noopener noreferrer">
                                        <div className="d-flex align-items-center">
                                            <div className="pr-2"><img src={whatsappicon} /></div>
                                            <div>whatsaap</div>

                                        </div>
                                    </Link>

                                </div>
                                <div className="mb-4">
                                    <Link  href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                                        <div className="d-flex align-items-center">
                                            <div className="pr-2"><img src={faceboookicon} /></div>
                                            <div>facebook</div>

                                        </div>
                                    </Link>

                                </div>
                                <div className="mb-4">
                                    <Link  href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                                        <div className="d-flex align-items-center">
                                            <div className="pr-2"><img src={instagramicon} /></div>
                                            <div>instagram</div>

                                        </div>
                                    </Link>

                                </div>
                                <div className="mb-4">
                                    <Link  href="https://x.com/kizzle" target="_blank" rel="noopener noreferrer">
                                        <div className="d-flex align-items-center">
                                            <div className="pr-2"><img src={twittericon} /></div>
                                            <div>twitter</div>

                                        </div>
                                    </Link>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    );
};

